import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Class } from '../../data/class';
import { Student } from '../../data/student';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-support-toolbox',
  templateUrl: './support-toolbox.component.html',
  styleUrls: ['./support-toolbox.component.scss']
})
export class SupportToolboxComponent extends BaseComponent implements OnInit {

}
